import { useDispatch } from 'react-redux';
import { changeFiltering } from '../redux/actions/filteringActions';

function Filtering(props: any) {
    const dispatch = useDispatch();

    //console.log("<Filtering, props.param")
    //console.log(props.param)

    return (
        <div>
        <span className='alignLeft'><h2><b>{props.caption}</b></h2></span>
        <div>
            {Object.entries(props.param).map((rodina: any) => 
                <span key={rodina[0]} className={rodina[1]===true?"filterBtnStyle filterBtnStyleSelected":"filterBtnStyle"}
                        onClick={()=>dispatch(changeFiltering({flag: props.flag, rodina: rodina[0], doporuceni: rodina[1]}))}>
                    {rodina[0]}
                </span>)}
        </div>
    </div>
    )
}
export default Filtering